// extracted by mini-css-extract-plugin
module.exports = {"container":"BrowseResultService-module--container--5348e1","name":"BrowseResultService-module--name--e01a4d","duration":"BrowseResultService-module--duration--b2fec0"};